import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from '../../booking/booking-services/booking.service';
import { SendTicketObject } from '../../booking/booking-services/model/ticket';
import { CommonService } from '../../common/services/common.service';
import { UserAccountService } from '../user-account.service';
import { RootObject,BookingDetailObject } from './model/booking-detail';

@Component({
    selector: 'app-booking-detail',
    templateUrl: 'booking-detail.component.html',
    styleUrls:['./booking-detail.component.css']
})

export class BookingDetailComponent implements OnInit {
    bookingDetails:BookingDetailObject=null;
    tripType:string='O'
    travelers=[{'initials':'Mr','firstName':'Sadique','lastName':'Puthukdu'},{'initials':'Mr','firstName':'Binil','lastName':'Bpx'}]
    passengerCounts:any={Adult:0,Child:0,Infant:0};
    
    constructor(private actRoute: ActivatedRoute,private _router: Router,public _commonService: CommonService, private _userAccountService: UserAccountService) { }

    ngOnInit() {
        this.getBookingDetail();
     }

    getBookingDetail(){

        this._userAccountService.getBookingDetail(this.actRoute.snapshot.params.id).subscribe((res:RootObject)=>{
           if(res.status == true && res.message == 'success'){
                console.log("ddd", res)
                this.bookingDetails = res.data;
           }
        })
    }

    public formatBirthdate(birthdate: any): Date {
      return new Date(birthdate.slice(0,4), birthdate.slice(4,6) - 1, birthdate.slice(6,8));
    }

    sendTicket(type:number,details:BookingDetailObject){
      if(details.departureBookResponse != null){
        if(details.departureBookResponse.pnr != null){
          var reqDept : SendTicketObject = {
            pnr : details.departureBookResponse.pnr,
            subject:'Travel Ticket',
            type:type,
            toEmail:details.request.mainBooker.email
          }
          this._userAccountService.sendTicket(reqDept).subscribe((res:any)=>{
            if(res.status == true && res.message == 'success'){
              alert("Message Send")
            }
          });
        }
      }
   
  
      if(details.returnBookResponse !=null){
        
        var reqDept : SendTicketObject = {
          pnr : details.returnBookResponse.pnr,
          subject:'Travel Ticket',
          type:type,
          toEmail:details.request.mainBooker.email
        }
        this._userAccountService.sendTicket(reqDept).subscribe((res:any)=>{
          if(res.status == true && res.message == 'success'){
            alert("Message Send")
          }
        });
      }
    }

    goBack(){
      this._router.navigate(['userAccount']);
    }

    getTotalAmount(){
        if(this.bookingDetails.request.returnBookingObject != null){

          return parseFloat(this.bookingDetails.request.departureBookingObject.salesAmount) + parseFloat(this.bookingDetails.request.returnBookingObject.salesAmount);
        }else if(this.bookingDetails.request.isMerged && this.bookingDetails.request.returnBookingObject == null){
          return parseFloat(this.bookingDetails.request.departureBookingObject.salesAmount);
        }
        else{
          return parseFloat(this.bookingDetails.request.departureBookingObject.salesAmount);
        }
         
      }

      print(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Print tab</title>
              <link rel="stylesheet" href="../../assets/css/style.css">
              <link rel="stylesheet" href="../../assets/css/bootstrap.css">
              <style>
              /*binil*/
              .hotel-card .discount {
                  z-index: 1;
                  line-height: 80px;
                  text-transform: uppercase;
                  font-weight: bold;
                  font-size: 0.9167em;
                  letter-spacing: 0.04em;
                  text-indent: -3px;
              }
              .hotel-card .discount .discount-text {
                  display: inline-block;
                  -webkit-transform: rotate(-45deg);
                  -moz-transform: rotate(-45deg);
                  -ms-transform: rotate(-45deg);
                  -o-transform: rotate(-45deg);
                  transform: rotate(-45deg);
                  writing-mode: lr-tb;
              }
              .discount-highlight .discount-text {
                  margin-left: 5px !important;
              }
              .hotel-card .has-discount:before, .hotel-card .discount {
                  display: block;
                  position: absolute;
                  /* left: 12px !important; */
                  top: -4px;
                  width: 100px;
                  height: 102px;
                  color: #fff;
                  /* background: url("../discount.png") no-repeat; */
              }
              .highlight-header .rating {
                  padding-left: 20px;
              }
              .five-stars-container {
                  display: inline-block;
                  position: relative;
                  font-size: 14px;
                  text-align: left;
                  cursor: default;
                  white-space: nowrap;
                  line-height: 1.2em;
                  color: #dbdbdb;
              }
              .five-stars-container:before {
                  display: block;
                  position: absolute;
                  top: 0;
                  left: 1px;
                  content: "\f5bc\f5bc\f5bc\f5bc\f5bc";
                  z-index: 0;
              }
              .highlight-header .five-stars-container .five-stars, .five-stars-container.editable-rating .ui-slider-range {
                  background: unset !important;
              }
              .five-stars-container .five-stars, .five-stars-container.editable-rating .ui-slider-range {
                  display: block;
                  overflow: hidden;
                  position: relative;
                  /* background: #fff; */
                  padding-left: 1px;
              }
              .five-stars-container .five-stars:before, .five-stars-container.editable-rating .ui-slider-range:before {
                  content: "\f5bc\f5bc\f5bc\f5bc\f5bc";
                  color: #fdb714;
              }
              .hotel-card .card-title {
                  text-align: center;
                  /* background-color: #f4fcff; */
                  padding: 15px 0;
                  color: #01b7f2;
                  font-weight: normal;
                  font-style: normal;
                  font-size: 20px;
                  /* line-height: 34px; */
                  font-weight: 600;
                  /* padding-left: 18px; */
                  letter-spacing: 0px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
              }
              .highlight-text-black {
                  color: #000 !important;
                  text-align: center;
                  font-weight: bold;
                  padding-bottom: 0;
                  margin-bottom: 0;
              }
              .highlight-box-price p {
                  /* padding-top: 15px; */
                  color: #7db921;
                  font-size: 19px;
                  text-transform: uppercase;
                  margin-bottom: 0 !important;
              }
              .highlight-box-price small {
                  font-size: 10px !important;
                  color: #000 !important;
              }
              .hotel-card button.green, input[type="button"].button.green, a.button.green {
                  background: #98ce44;
              }
              .hotel-card a.button.btn-large, a.button.btn-medium, a.button.btn-small, a.button.full-width {
                  font-weight: bold;
              }
              .hotel-card button.btn-small, input[type="button"].button.btn-small, a.button.btn-small {
                  height: 28px;
                  padding: 0 24px;
                  line-height: 28px;
                  font-size: 0.9167em;
                  border-radius: 5px;
                  color: #ffff;
                  text-align: center;
                  text-transform: capitalize;
                  font-weight: 400;
                  box-shadow: unset;
              }
              .hotel-card button.green:hover, input[type="button"].button.green:hover, a.button.green:hover {
                  background: #7fb231;
                  color: #fff;
              }
              /*binil*/
              
              
              
              .flight-multiple-list .row
              {
                border-bottom:solid 1px #ccc;
                align-items: center;
                padding-top: 15px;
                padding-bottom: 15px;
              }
              .flight-multiple-list .row:nth-last-child(1)
              {
                border-bottom: 0;
              }
              .fl-steps {
                 display: flex;
                 justify-content: space-between;
                 padding: 50px 0 20px;
                 margin: auto;
                 max-width: 80%;
                 padding-bottom: 30px;
              }
              .fl-steps .title-p
              {
                position: absolute;
                top: 35px;
                width: max-content;
              }
              .fl-steps .title-p.ps
              {
                right: -35px;
              }
              .fl-steps .title-p.pa
              {
                right: -13px;
              }
              .fl-steps .title-p.in
              {
                right: -6px;
              }
               .fl-steps li {
                 list-style: none;
                 display: flex;
                 justify-content: center;
                 align-items: center;
                 flex-flow: nowrap;
                 width: 100%;
                 padding: 0;
                 position: relative;
              }
               .fl-steps li:first-child {
                 width: auto;
              }
               .fl-steps li:first-child:before {
                 display: none;
              }
               .fl-steps li:first-child span {
                 width: 40px;
              }
               .fl-steps li span {
                 border-radius: 100px;
                 display: block;
                 height: 40px;
                 width: 100%;
                 max-width: 40px;
                 background: #fff;
                 color: #ccc;
                 border: 4px solid #ccc;
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 font-size: 2rem;
                 z-index: 2;
                 transition: all 0.45s;
              }
               .fl-steps li:before {
                 content: "";
                 height: 5px;
                 background: #ccc;
                 width: 100%;
                 display: block;
              }
               .fl-steps li:after {
                 width: 0px;
                 content: "";
                 position: absolute;
                 height: 5px;
                 background:#81bb28;
                 transition: all 0.6s;
                 left: 0;
                 z-index: 1;
              }
               .fl-steps li.actived:after {
                 width: 100%;
              }
               .fl-steps li.actived:before {
                 color: #fff;
              }
               .fl-steps li.actived span {
                 background: #fff;
                 border-color:#81bb28;
                 transition-delay: 0.45s;
                 color:#81bb28;
              }
              .fl-steps li.actived .title-p{
                 color: #fff;
              }
               .fl-steps i
               {
                 font-size: .7em;
               }
              .price span
              {
                display: inline-block;
              }
              .price label
              {
                color: #000;
              }
              .baggage
              {
                display: flex;
                  flex-direction: column;
              }
              .day-select
              {
                background: #fff;
                  border-top-right-radius: 20px;
                  border-top-left-radius: 20px;
                  overflow: hidden;
                  font-weight: 600;
              }
              .day-select .col-2
              {
                padding: 0;
              }
              .day-select .day
              {
                background: #c62a82;
                display: block;
                color: #fff;
                padding: 10px;
                cursor: pointer;
              }
              .day-select .day:hover
              {
                background: #b12674;
                transition: .4s;
              }
              .flight
              {
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .flight-list:hover {
                 cursor: pointer;
                 box-shadow: 0px 5px 10px 0px rgba(81, 98, 121, 0.33)!important;
              }
              .list-tickets .flight-list
              {
                margin-top: 15px;
              }
              .list-tickets .flight-list:nth-child(1)
              {
                margin-top: 0!important;
              }
              .flight-list .date
              {
                display: flex;
                  flex-direction: column;
              }
              .fl-filter .form-check-input
              {
                margin-top: 5px;
              }
              .list-item-logo
              {
                width: max-content!important;
                margin-right: 10px;
              }
              .mt-136
              {
                margin-top: 136px !important;
              }
              .fl-filter
              {
                padding-right: 0;
              }
              .flight-list
              {
                padding-top: 0.5rem !important;
                padding-bottom: 0.5rem !important;
              }
              @media(max-width: 1024px)
              {
                .flight-selection
                {
                  max-width: 100%;
                }
              }
              @media(max-width:991px)
              {
                .flight-selection
                {
                  max-width: 100%;
                }
                .flight-list .list-item-inner
                {
                  display: block;
                }
                .flight-list .list-item-footer
                {
                  margin-left: 0;
                  text-align: right;
                }
              }
              @media(max-width: 895px)
              {
                .list-item-top
                {
                  display: block !important;
                }
                .flight-list  .list-item-logo
                {
                  /*width: 20%;*/
                  display:inline-block;
                }
                .flight-list  .date
                {
                  /*width: 40%;*/
                  display:inline-block;
                }
                .flight-list .baggage
                {
                  /*width: 38%;*/
                  display:inline-block;
                }
                .fl-in
                {
                  display: flex;
                }
              }
              @media(max-width: 768px)
              {
                .flight-list .list-item-content
                {
                  display: flex;
                    margin-left: auto;
                    justify-content: center;
                }
                .flight-list .list-item-top
                {
              
                    display: block!important;
                    width: 100%;
                    flex-basis:unset;
                }
                  .fl-in
                  {
                    justify-content: center;
                  }
              
              }
              @media(max-width:496px)
              {
                .list-item-top
                {
                  text-align: right;
                }
                .fl-steps .title-p {
                    font-size: 0.8rem;
                }
                .fl-steps .title-p.ps {
                    right: -25px;
                }
                .fl-steps .title-p.pa {
                    right: -6px;
                }
                .fl-steps .title-p.in {
                    right: -1px;
                }
              }
              
              
              /*passenger-data*/
              .passenger-data
              {
                text-align: right;
              }
              .passenger-data i
              {
                font-size: 2em;
                  color: #b2b9d2;
              }
              .passenger-data h3
              {
                font-size: 1.6em;
              }
              .passenger-data p
              {
                margin: 0;
              }
              .passport-info img
              {
                width: 80px;
                height: 80px;
              }
              .passport-info
              {
                display: flex;
              }
              .passenger-nfo .card-header
              {
                font-size: 1.3em;
              }
              .passenger-form input[type="text"],.passenger-form .btn
              {
                height: 48px;
              
              }
              .divider
              {
                border: dashed 1px #bdc1d2;
              }
              .icon-stack .fa-lock
              {
                position: absolute;
                  top: -6px;
                  background: #fff;
                  /* border: solid; */
                  border-radius: 50%;
                  width: 28px;
                  height: 28px;
                  right: -19px;
                  font-size: 1.5em;
                  text-align: center;
                  line-height: 28px;
              }
              .icon-stack 
              {
                position: relative;
                color: #af3469;
              }
              .icon-stack .fa-user
              {
                font-size: 3em;
              }
              .f-login
              {
                background: #fff;
              }
              .f-login h4
              {
                color: #af3469;
              }
              .fl-login-btn i
              {
                font-size: 1.3em;
                  margin-left: 5px;
              }
              .fl-login-btn
              {
                padding: 15px 30px;
              }
              /*passenger-data-end*/
              /* =================== */
              /*   Pricing Wrapper   */
              /* =================== */
              .risk-title
              {
                font-size: 1.4em;
                  font-weight: 600;
              }
              .price-outer
              {
                color: #af3469;
                font-size: 28px;
                font-weight: 600;
              }
              .price-outer sup
              {
                font-weight: 300;
              }
              .mt-100
              {
                margin-top: 100px !important;
              }
              
              .pricing-wrapper:hover .current {
                top: 0;
                padding-bottom: 20px;
                padding-top: 20px;
              }
              
              .pricing-wrapper:hover .current .pricing-card {
                -webkit-transition: all 0.2s linear 0s;
                        transition: all 0.2s linear 0s;
                box-shadow: none;
              }
              
              .pricing-wrapper:hover .current .pricing-footer {
                height: 80px;
              }
              
              .pricing-wrapper:hover .current .pricing-footer a {
                bottom: 0;
                position: relative;
              }
              
              .pricing-wrapper:hover .current:hover {
                top: 0;
                padding-top: 0;
                padding-bottom: 0;
              }
              
              .pricing-wrapper:hover .current:hover .pricing-card {
                box-shadow: 0 0 20px -2px rgba(0, 0, 0, 0.25);
              }
              
              .pricing-wrapper:hover .current:hover .pricing-footer {
                height: 120px;
              }
              
              .pricing-wrapper:hover .current:hover .pricing-footer a {
                bottom: -20px;
                position: relative;
              }
              
              .stripped-table [class*=col-] {
                padding: 0;
                margin: -1px;
              }
              
              .stripped-table .pricing-col {
                padding: 20px 0;
              }
              
              .stripped-table.current {
                padding-left: 0;
                padding-right: 0;
              }
              
              .stripped-table .ribbon {
                left: calc(100% - 124px);
              }
              
              /* =================== */
              /*   Pricing Cards     */
              /* =================== */
              .pricing-card {
                position: relative;
                border: 1px solid #ddd;
                width: 100%;
                top: 0;
                -webkit-transition: all 0.2s linear 0s;
                        transition: all 0.2s linear 0s;
                z-index: 99;
              }
              
              /* =================== */
              /*   Pricing Header    */
              /* =================== */
              .pricing-header {
                background: #fff;
                position: relative;
                height: 200px;
                border-bottom: 1px solid #1976d2;
                margin: -1px;
                margin-bottom: 0;
                text-align: center;
              }
              
              .pricing-header h5 {
                color: #fff;
                font-size: 16px;
                line-height: normal;
                margin: 0 auto;
                text-transform: uppercase;
                margin-bottom: 5px;
              }
              
              .pricing-header p {
                margin: 0 auto;
                color: #fff;
                display: inline-block;
                font-style: italic;
              }
              
              .pricing-feature {
                position: relative;
                text-align: left;
              }
              
              .pricing-feature li {
                list-style: none;
                padding: 13px 0;
                border-bottom: 1px solid #ddd;
                background: #eee;
              }
              
              .pricing-feature li:last-child {
                border-bottom: none;
              }
              
              .pricing-feature li span {
                text-transform: capitalize;
                font-weight: bold;
              }
              
              .pricing-feature li span, .pricing-feature li i {
                float: right;
              }
              
              .pricing-feature li p {
                margin: 0;
                font-size: 13.5px;
                text-transform: capitalize;
                padding: 0 20px;
                line-height: normal;
              }
              
              /* ============================ */
              /*   Pricing Footer             */
              /* ============================ */
              .pricing-footer {
                border-top: 1px solid #ddd;
                padding: 0 20px;
                height: 80px;
                -webkit-transition: height 0.2s linear 0s;
                        transition: height 0.2s linear 0s;
                text-align: center;
              }
              
              .pricing-footer a {
                bottom: 0;
                margin-top: 20px;
                position: relative;
              }
              
              /* =================== */
              /*   Pricing Ribbons     */
              /* =================== */
              .ribbon {
                background: #222;
                box-shadow: 0 1px 5px rgba(0, 0, 0, 0.23), 0 1px 5px rgba(0, 0, 0, 0.16);
                height: 35px;
                line-height: 35px;
                margin: 0 auto;
                position: absolute;
                left: calc(100% - 110px);
                top: 70px;
                width: 35px;
                z-index: 10;
                -webkit-transition: all 0.2s linear;
                        transition: all 0.2s linear;
                border-radius: 100px;
                float: right;
                cursor: pointer;
              }
              
              .ribbon:hover {
                width: 90px;
              }
              
              .ribbon:hover span {
                visibility: visible;
                -webkit-transition: all 0.2s linear 0.18s;
                        transition: all 0.2s linear 0.18s;
              }
              
              .ribbon span {
                top: 0;
                color: #ffffff;
                font-size: 13px;
                font-weight: 500;
                float: left;
                visibility: hidden;
              }
              
              .ribbon i {
                color: #FFC61B;
                font-weight: 800;
                font-size: 14px;
                margin: 11px;
                z-index: 10;
                float: left;
              }
              
              /* ======================= */
              /*   Pricing Comparison    */
              /* ======================= */
              .comparison-table [class*=col-] {
                padding: 0;
                margin: -1px;
              }
              
              .comparison-table .pricing-col {
                padding: 20px 0;
              }
              
              .comparison-table.current {
                padding-left: 0;
                padding-right: 0;
              }
              
              .comparison-table [class*=col-]:first-child {
                margin: 0;
              }
              
              .comparison-table [class*=col-]:first-child:hover {
                top: 0;
                padding-top: 20px;
                padding-bottom: 20px;
              }
              
              .comparison-table [class*=col-]:first-child:hover .pricing-card {
                margin: 0;
                box-shadow: none;
              }
              
              .comparison-table .pricing-feature li {
                background: #fff;
                text-align: center;
              }
              
              .comparison-table .pricing-feature li i {
                line-height: normal;
              }
              
              .comparison-table .pricing-feature li span, .comparison-table .pricing-feature li i {
                float: none;
              }
              
              .comparison-table .pricing-feature li:nth-child(2n+1) {
                background: #eee;
              }
              
              .comparison-table .ribbon {
                left: calc(100% - 124px);
              }
              
              .list-feature {
                z-index: 0;
              }
              
              .list-feature .pricing-header {
                background: #fff !important;
                padding: 30px 15px;
                border-bottom-color: #ddd !important;
                text-align: center;
                margin-top: -2px;
              }
              
              .list-feature .pricing-header h5 {
                background: #fff !important;
                color: #424242;
                font-weight: 500;
                font-size: 16px;
                padding: 0;
                margin-top: 30px;
              }
              
              .list-feature .pricing-header p {
                color: #444;
                margin-top: 5px;
              }
              
              .list-feature .pricing-feature {
                text-align: left;
              }
              
              .pricing-col {
                -webkit-transition: all 0.2s linear 0s;
                        transition: all 0.2s linear 0s;
                padding-top: 20px;
                padding-bottom: 20px;
              }
              
              .pricing-col:hover {
                padding-bottom: 0;
                padding-top: 0;
              }
              
              .pricing-col:hover > .only-pricing {
                top: 0px;
                box-shadow: 0 0 20px -2px rgba(0, 0, 0, 0.25);
                -webkit-transition: all 0.2s linear 0s;
                        transition: all 0.2s linear 0s;
                z-index: 101;
              }
              
              .pricing-col:hover > .pricing-card .pricing-footer {
                height: 120px;
              }
              
              .pricing-col:hover > .pricing-card .pricing-footer a {
                bottom: -20px;
                position: relative;
              }
              
              .pricing-col.current {
                padding-top: 0;
                padding-bottom: 0;
                margin-left: 0;
                margin-right: 0;
              }
              
              .current {
                top: 0;
              }
              
              .current .pricing-card {
                z-index: 100;
                -webkit-transition: all 0.2s linear 0s;
                        transition: all 0.2s linear 0s;
                box-shadow: 0 0 20px -2px rgba(0, 0, 0, 0.25);
              }
              
              .current .pricing-footer {
                height: 120px;
              }
              
              .current .pricing-footer a {
                bottom: -20px;
                position: relative;
              }
              
              .current:hover {
                -webkit-transition: all 0.2s linear 0s;
                 transition: all 0.2s linear 0s;
                top: -20px;
              }
              
              .current:hover .pricing-footer {
                height: 120px;
              }
              
              .current:hover .pricing-footer a {
                bottom: -20px;
                position: relative;
              }
                .matraz_menu .logo {
                  margin-left: auto;
                  margin-top: 5px;
                  width: 150px;
                }
                .trac_mobtrac_menu { text-align:center; display:none; }
                .trac_mobtrac_menu li { padding:10px 0; }
                .trac_mobilelink_button  { display:none; margin-right:10px; cursor:pointer; margin-top:10px; }
              
                .logo{
                  float: left;
                }
                .logo h1{
                  margin-bottom: 0;
                  margin-top: 10px;
                }
              .style-2 .pricing-card,
              .style-2 .pricing-footer {
                border: none;
              }
              
              .style-2 .pricing-header {
                margin: 0;
                border: none;
                height: 160px;
              }
              
              .style-2 .pricing-feature li {
                background: none;
                border-color: #42a5f5;
              }
              
              .style-2 .pricing-feature li p {
                color: #e3f2fd;
              }
              
              .style-2 .pricing-feature li p span, .style-2 .pricing-feature li p i {
                float: right;
                color: #fff;
              }
              
              .style-2 .pricing-feature li p .tooltip-content {
                color: #444;
              }
              
              .style-2 .pricing-feature li:last-child {
                border-bottom: 1px solid transparent;
              }
              
              .style-2 .price-box {
                margin: 20px auto;
                border-radius: 0;
                width: auto;
                height: auto;
                line-height: normal;
              }
              
              .style-2 .price-box:before {
                display: none;
                position: relative;
              }
              
              .style-2 .plan {
                bottom: 12px;
                left: auto;
                margin: 0;
                left: calc(100% + 5px);
                font-weight: 400;
                font-size: 12px;
                width: 50px;
                text-align: left;
              }
              
              .style-2 .currency {
                top: auto;
                font-size: 30px;
                left: -20px;
                line-height: inherit;
                position: absolute;
                bottom: 10px;
                letter-spacing: 0;
                font-weight: 300;
              }
              
              .style-2 .price {
                font-size: 60px;
                font-weight: 400;
              }
              
              .style-2 .ribbon {
                top: 35%;
                right: -10px;
                left: auto;
                border-radius: 0;
              }
              
              .style-2 .ribbon:after {
                border-right: 10px solid transparent;
                border-top: 7px solid rgba(0, 0, 0, 0.5);
                bottom: -7px;
                content: "";
                position: absolute;
                right: 0;
              }
              
              .style-2 .pricing-footer a:before {
                background: inherit;
              }
              
              .style-2.comparison-table .pricing-feature li:nth-child(2n+1) {
                background: inherit;
              }
              
              .style-2.comparison-table .pricing-feature li p {
                color: #fff;
              }
              
              .style-2.comparison-table .pricing-feature li p span, .style-2.comparison-table .pricing-feature li p i {
                float: none;
              }
              
              .style-2.comparison-table .list-feature .pricing-header {
                margin: 0;
                margin-bottom: -1px;
              }
              
              .style-2.comparison-table .list-feature .pricing-header h5 {
                margin-top: 0;
                font-size: 38px;
              }
              
              .style-2 .btn-act.btn-line {
                background: none;
                border-color: #fff;
                color: #fff;
              }
              
              .style-2 .btn-act.btn-bg:hover {
                background: #212121;
                border-color: #212121;
              }
              
              
              
              
              
              .style-3 .pricing-card {
                border: 1px solid #ddd;
              }
              
              .style-3 .pricing-header {
                border-bottom: none;
                margin: 0;
                height: 130px;
              }
              
              .style-3 .pricing-header h5 {
                color: #424242;
                font-weight: 600;
              }
              
              .style-3 .price-box {
                border-radius: 0;
                width: 100%;
                height: auto;
                border-bottom: 1px solid #ddd;
              }
              
              .style-3 .price {
                color: #616161;
                font-size: 18px;
                font-weight: 400;
                line-height: normal;
              }
              
              .style-3 .currency {
                top: 12px;
                font-size: 22px;
                left: -16px;
                font-weight: 300;
              }
              
              .style-3 .plan {
                bottom: 12px;
                left: auto;
                margin: 0;
                left: calc(100% + 5px);
                font-weight: 400;
                font-size: 12px;
                width: 50px;
                text-align: left;
                line-height: normal;
              }
              
              .style-3 .pricing-feature li {
                background: #f5f5f5;
              }
              
              .style-3 .pricing-feature li:first-child {
                border-top: 1px solid #ddd;
              }
              
              .style-3 .pricing-feature li span, .style-3 .pricing-feature li i {
                float: right;
              }
              
              .style-3 .pricing-feature li:nth-child(2n+1) {
                background: #eee;
              }
              
              .style-3 .ribbon {
                top: -11%;
                right: -10px;
                left: auto;
                border-radius: 0;
              }
              
              .style-3 .ribbon:after {
                border-right: 10px solid transparent;
                border-top: 7px solid rgba(0, 0, 0, 0.5);
                bottom: -7px;
                content: "";
                position: absolute;
                right: 0;
              }
              
              .style-3 .person .price {
                color: #2196f3;
              }
              
              .style-3 .person .plan {
                color: #757575;
              }
              
              .style-3 .corp .price {
                color: #4caf50;
              }
              
              .style-3 .corp .plan {
                color: #757575;
              }
              
              .style-3 .unlim .price {
                color: #f44336;
              }
              
              .style-3 .unlim .plan {
                color: #757575;
              }
              
              .style-3 .business .price {
                color: #ffc107;
              }
              
              .style-3 .business .plan {
                color: #757575;
              }
              
              .style-3 .pricing-footer {
                background: #fff;
              }
              
              .style-3.comparison-table [class*=col-]:first-child {
                margin: -1px;
              }
              
              .style-3.comparison-table .list-feature .pricing-header h5 {
                margin-top: 0;
                border-bottom: none;
              }
              
              .style-3.comparison-table .pricing-feature li p, .style-3.comparison-table .pricing-feature li i, .style-3.comparison-table .pricing-feature li span {
                float: none;
              }
              
              .style-3 .pricing-footer .btn-act.btn-line {
                background: none;
                border-color: #2196f3;
                color: #2196f3;
              }
              
              .style-3 .pricing-footer .btn-act.btn-line:hover {
                background: #2196f3;
                border-color: #2196f3;
                color: #fff;
              }
              
              .style-3 .pricing-footer .btn-act.btn-bg {
                background-color: #2196f3;
                border-color: #2196f3;
              }
              
              .style-3 .pricing-footer .btn-act.btn-bg:hover {
                background: #212121;
                border-color: #212121;
              }
              section.footer {
                  background: #F5F5F5;
                  text-align: center;
                  font-size: 20px;
              }
              .pricing-header-1
              {
                height: 48px !important;
                padding: 0 !important;
                text-align: center !important;
                display: flex;
                align-items: center;
              }
              .pricing-card-1
              {
                top: 83px;
              }
              /* The container */
              .custom-radio {
                display: block;
                position: relative;
                padding-left: 0;
                margin-bottom: 0;
                cursor: pointer;
                font-size: 22px;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                width: 35px;
                height: 35px;
              }
              
              /* Hide the browser's default radio button */
              .custom-radio input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
              }
              
              /* Create a custom radio button */
              .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 30px;
                width: 30px;
                background-color: #eee;
                border-radius: 50%;
              }
              
              /* On mouse-over, add a grey background color */
              .custom-radio:hover input ~ .checkmark {
                background-color: #ccc;
              }
              
              /* When the radio button is checked, add a blue background */
              .custom-radio input:checked ~ .checkmark {
                background-color: #2196F3;
              }
              
              /* Create the indicator (the dot/circle - hidden when not checked) */
              .checkmark:after {
                content: "";
                position: absolute;
                display: none;
              }
              
              /* Show the indicator (dot/circle) when checked */
              .custom-radio input:checked ~ .checkmark:after {
                display: block;
              }
              
              /* Style the indicator (dot/circle) */
              .custom-radio .checkmark:after {
                 top: 8px;
                left: 8px;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background: white;
              }
              /* ======================== */
              /*   Pricing end             */
              /* ======================== */
              
              /*payment-start*/
              .ticket-card,.ticket-card th
              {
                font-weight: 300;
              }
              .ticket-card
              {
                overflow: hidden;
              }
              .price-table td
              {
                padding: 5px;
              }
              .ticket-card th
              {
                font-size: 11px;
                padding: 5px;
              }
              .ticket-card thead
              {
                border-bottom: dashed 1px #ccc;
              }
              .ticket-card h4
              {
                padding: 15px;
                text-align: left;
                color: #c62a82;
              }
              .border-bottom-t
              {
                border-bottom: solid 2px #f3f4f7;
              }
              .f-14
              {
                font-size: 14px;
              }
              .text-white
              {
                color: #fff!important;
              }
              .bg-total
              {
                background: #c62a82;
                border-bottom: dashed 2px #f3f4f7;
                position: relative;
              }
              .bg-total::before
              {
                content: "";
                position: absolute;
                  width: 60px;
                  height: 60px;
                  background: #f3f4f7;
                  border-radius: 50%;
                  left: 50%;
                  right: 50%;
                  transform: translate(-50%,-50%);
                  bottom: -70px;
              }
              .accordion .card-header
              {
                background: #fff;
              }
              /*payment-end*/
              @media(max-width: 767px)
              {
                .pricing-card-1 {
                    top: 0;
                }
              }
              @media(max-width: 991px)
              {
                .flex-direction-column-991
                {
                  flex-direction: column-reverse;
                }
              }
              /*25/08/2020*/
              .flight-search-sub
              {
                background: #21b5ea;
                padding-top: 15px;
                padding-bottom: 15px;
                color: #fff;
                    position: sticky;
                  top: 0;
                  left: 0;
                  z-index: 9999;
                  position:  -webkit-sticky;
              }
              .flight-search-sub h4
              {
                color: #fff;
              }
              .flight-search-sub .form-label-outside
              {
                color: #fff;
              }
              .flight-search-sub .select2-selection--single,.flight-search-sub .form-input
              {
                background: #268dc1 !important;
                border: none !important;
                color: #fff !important;
                height: 35px !important;
                line-height: 35px !important;
              }
              .flight-search-sub .select2-selection__rendered
              {
                 color: #fff !important;
              }
              .flight-search-sub .form-input
              {
                min-height: 35px !important;
                line-height: 35px !important;
              }
              .flight-search-sub .dropdown .btn-secondary
              {
                  height: 35px;
                  background: #268dc1;
                  font-weight: 300;
                  border: 0;
              }
              .flight-search-sub .btn-search
              {
                  height: 35px;
                  line-height: 28px;
                  padding: 5px 20px;
                  margin-top: 27px;
              }
              .flight-search-sub .dropdown-menu .form-label-outside
              {
                color: #333;
              }
              /*new-list-item-style*/
              .baggage-icon i
              {
                font-size: 18px;
                color: #56c364;
              }
              .list-item-inner, .list-item-inner .small
              {
                font-size: 12px !important;
              }
              .select-flight
              {
                  color: #c73e82 !important;
                  display: inline-block;
                  background: #ffd3e9;
                  font-size: 12px;
                  padding: 5px 10px;
                  border-radius: 5px;
              
              }
              .select-flight:hover
              {
                cursor: pointer;
                background: #c73e82 !important;
                color: #fff!important;
              
              }
              .list-item-logo img
              {
                width: 50px;
              }
              .list-tickets li.flight-list
              {
                margin:0!important;
                border: solid 1px #dee2e6;
                border-top: 0;
              }
              .list-tickets li.flight-list:hover {
                  -webkit-transform: scale(1.006);
                  -ms-transform: scale(1.006);
                  transform: scale(1.006);
                  -webkit-box-shadow: 0 0 6px 0 rgba(0,0,0,.2) !important;
                  box-shadow: 0 0 6px 0 rgba(0,0,0,.2) !important;
                  border: none;
              }
              @media (max-width: 687px)
              {
                .list-item-price
                {
                  font-size: 14px;
                }
                .select-flight {
                 
                  padding: 5px 5px;
                }
              }
              @media (max-width: 628px)
              {
                .select-flight {
                 
                  padding: 2px 2px;
                }
                .select-flight span{
                 
                  display: none;
                }
                 .select-flight i{
                 
                  font-size: 14px;
                }
              }
              @media (max-width: 462px)
              {
                .list-item-price
                {
                  font-size: 12px;
                }
                .day-select .day
                {
                  font-size: 12px!important;
                }
                .list-item-inner .col-2
                {
                  padding-left: 5px;
                  padding-right: 5px;
                }
              }
              .edit-section
              {
                 background: #fff;
                 border-top: solid 1px #dee2e6;
                 border-bottom: solid 1px #dee2e6;
                 color: #333;
              }
              .edit-section small
              {
                color: #808080;
              }
              .edit-section a
              {
                color: #3981de!important;
              }
              .edit-section a:hover
              {
                text-decoration: underline !important;
                cursor: pointer;
              }
              .f-filter-card
              {
                cursor: pointer;
              }
              .f-filter-card .filter-active svg
              {
                fill: #fff;
              
              }
              
              .f-filter-card .filter-active
              {
                 color: #fff!important;
                background: #28b4e9;
              }
              @media (max-width: 991px)
              {
              .flight-list .list-item-inner {
                  display: flex !important;
              }
              .page
              {
                overflow: unset!important;
              }
              .flight-search-sub
              {
                display: none;
              }
              .filter-sticky
              {
                height: auto;
              }
              }
              @media(min-width: 768px)
              {
                .filter-sticky
                {
                  height: 85vh;
                    overflow-y: auto;
                }
              }
              @media (max-width: 600px)
              {
                .f-filter-card small
                {
                  font-size: 10px;
                }
                .f-filter-card 
                {
                  margin-right: -5px !important;
                    margin-left: -5px !important;
                }
                .f-filter-card .col-2
                {
                  padding-right: 5px !important;
                    padding-left: 5px !important;
                }
                .baggage-icon i {
                  font-size: 12px;
                  color: #56c364;
                }
                .flight
                {
                  font-size: 12px;	
                }
              }
              
              @media (max-width: 450px)
              {
                .f-filter-card small
                {
                  font-size: 8px;
                }
                .f-filter-card svg
                {
                  width: 16px;
                }
                .day-select .day {
                  font-size: 10px!important;
                }
                
              }
              @media (max-width: 360px)
              {
                .list-item-logo img {
                  width: 33px;
                }
                .list-item-inner, .list-item-inner .small {
                  font-size: 10px !important;
                }
              }
              @media (max-width: 320px)
              {
                .f-filter-card 
                {
                  margin-right: 0px !important;
                    margin-left: 0px !important;
                }
                .f-filter-card .col-2
                {
                  padding-right: 0px !important;
                    padding-left: 0px !important;
                }
                
              }
              
              
              .lab-card{
                  color:#81bb28;
                }
              
                ul.check-square li:before {
                  content: "\f222";
                  padding: 1px 4px 0;
                  margin-right: 10px;
                  font-size: 12px;
              }
              
              .font-general{
                font-size: 0.8333em;
                text-transform: uppercase;
              }
              
              .htl-checks ul li span,.htl-checks ul li p
              {
                  font-family: "Lato", Helvetica, Arial, sans-serif;
                  color: #14b300;
              }
              .htl-checks ul li p
              {
                  color:  #808080;
              }
              .htl-checks ul li::before
              {
                  color: #14b300;
                  font-size: 16px;
              }
              .htl-checks ul li
              {
                  margin-bottom: 15px;
              }
              </style>
            </head>
        <body onload="window.print();">${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }
}